export var getCookie = function (cookieName) {
    var match = document.cookie.match(new RegExp(cookieName + "=([^;]+)"));
    return match ? match[1] : undefined;
};
